import './wdyr.ts';

import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './index.css';
import * as serviceWorker from './serviceWorker';
import { environment } from './environment';
import ReactModal from 'react-modal';

const rootElement = document.getElementById('root');
const root = createRoot(rootElement!);
root.render(<App />);
ReactModal.setAppElement(rootElement!);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();

if (environment.isDevelopment && (module as any).hot) {
  (module as any).hot.accept('./App', () => {
    const NextApp = require('./App').default;
    root.render(<NextApp />);
  });
}
